<template>
  <v-app>
    <nav>
      <v-app-bar app dark>
        <v-app-bar-nav-icon @click.stop="showDrawer=!showDrawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="headline text-uppercase">GlobalCash Custom Export</v-toolbar-title>
        <v-spacer/>
        <api-key-toolbar-button/>
      </v-app-bar>
      <v-navigation-drawer app v-model="showDrawer">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              GlobalCash
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense nav>
          <v-list-item
                  :key="item.title"
                  @click="$router.push(item.route)"
                  link
                  v-for="item in navItems"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </nav>

    <v-content>
      <router-view v-if="isApiKeyValid"/>
      <v-container v-else>
        <div class="d-flex justify-center">
          <v-progress-linear indeterminate v-if="isApiKeyVerifying"/>
          <span v-else>Une clé d'API valide est nécessaire pour continuer</span>
        </div>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>

  import {mapState} from 'vuex'

  import ApiKeyToolbarButton from "./components/ApiKeyToolbarButton";

  export default {
    name: 'App',
    components: {ApiKeyToolbarButton},
    data() {
      return {
        showDrawer: false,
        navItems: [
          {icon: "view_list", title: "Liste des exports", route: "/"},
          {icon: "build", title: "Génération manuelle", route: "/manual"},
          {icon: "info", title: "Documentation", route: "/doc"},
        ]
      }
    },
    computed: mapState({
      isApiKeyValid: state => state.isApiKeyValid,
      isApiKeyVerifying: state => state.isApiKeyVerifying
    })
  };
</script>

<style>
</style>
